export const isNonProviderView = (pathname: string) =>
  pathname.includes("patients");
